import classNames from 'classnames';
import { AnchorHTMLAttributes } from 'react';
import styles from './Link.module.scss';
import { Slot } from '@radix-ui/react-slot';

type Props = {
  appearance?: 'regular' | 'text-body' | 'dark';
  asChild?: boolean;
  underline?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link = ({
  className,
  asChild,
  appearance = 'regular',
  underline = true,
  ...props
}: Props) => {
  const Comp = asChild ? Slot : 'a';
  return (
    <Comp
      className={classNames(
        {
          'cp-text-link': appearance === 'regular',
          [styles.textBody]: appearance === 'text-body',
          'cp-text-link-dark': appearance === 'dark',
        },
        underline,
        className,
      )}
      {...props}
    />
  );
};
